module.exports = __webpack_public_path__ + "img/swiper6.9d6b60d1.png";